// index.ts
import axios from "axios";

// ../../node_modules/.pnpm/radashi@12.3.4/node_modules/radashi/dist/radashi.js
function assign(initial, override) {
  if (!initial || !override) {
    return initial ?? override ?? {};
  }
  const proto = Object.getPrototypeOf(initial);
  const merged = proto ? { ...initial } : Object.assign(Object.create(proto), initial);
  for (const key of Object.keys(override)) {
    merged[key] = isPlainObject(initial[key]) && isPlainObject(override[key]) ? assign(initial[key], override[key]) : override[key];
  }
  return merged;
}
function isPlainObject(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return (
    // Fast path for most common objects.
    prototype === Object.prototype || // Support objects created without a prototype.
    prototype === null || // Support plain objects from other realms.
    Object.getPrototypeOf(prototype) === null
  );
}

// ../max/_utils/intl/locales/zh-CN.ts
var zh_CN_default = {
  "request.response_status_code.400": "\u8BF7\u6C42\u9519\u8BEF",
  "request.response_status_code.401": "\u672A\u6388\u6743\uFF0C\u8BF7\u767B\u5F55",
  "request.response_status_code.403": "\u62D2\u7EDD\u8BBF\u95EE",
  "request.response_status_code.404": "\u8BF7\u6C42\u5730\u5740\u51FA\u9519",
  "request.response_status_code.408": "\u8BF7\u6C42\u8D85\u65F6",
  "request.response_status_code.500": "\u670D\u52A1\u5668\u5185\u90E8\u9519\u8BEF",
  "request.response_status_code.502": "\u7F51\u5173\u9519\u8BEF",
  "request.response_status_code.503": "\u670D\u52A1\u4E0D\u53EF\u7528",
  "request.response_status_code.504": "\u7F51\u5173\u8D85\u65F6",
  "request.response_status_code.other": "\u8FDE\u63A5\u51FA\u9519",
  "request.no_response": "\u8FDE\u63A5\u51FA\u9519",
  "request.error": "\u8BF7\u6C42\u9519\u8BEF",
  "login.btn.login": "\u767B\u5F55",
  "login.btn.logout": "\u9000\u51FA",
  "login.btn.forgot_password": "\u5FD8\u8BB0\u5BC6\u7801",
  "login.btn.edit_password": "\u4FEE\u6539\u5BC6\u7801",
  "login.captcha.phone": "\u624B\u673A\u53F7",
  "login.captcha.email": "\u90AE\u7BB1",
  "login.placeholder.phone": "\u8BF7\u8F93\u5165\u624B\u673A\u53F7",
  "login.placeholder.email": "\u8BF7\u8F93\u5165\u90AE\u7BB1",
  "login.type.account": "\u8D26\u53F7\u767B\u5F55",
  "login.type.captcha": "\u9A8C\u8BC1\u7801\u767B\u5F55",
  "login.type.feishu": "\u98DE\u4E66\u767B\u5F55",
  "login.input.required": "\u8BF7\u8F93\u5165",
  "login.password.mismatch": "\u60A8\u8F93\u5165\u7684\u4E24\u4E2A\u5BC6\u7801\u4E0D\u5339\u914D!",
  "login.password.required": "\u8BF7\u8F93\u5165\u5BC6\u7801",
  "login.verification.required": "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801",
  "login.verification.placeholder": "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801",
  "login.verification.get": "\u83B7\u53D6\u9A8C\u8BC1\u7801",
  "login.password.confirm.required": "\u8BF7\u8F93\u5165\u786E\u8BA4\u5BC6\u7801",
  "login.password.confirm.placeholder": "\u8BF7\u8F93\u5165\u786E\u8BA4\u5BC6\u7801",
  "login.submit": "\u63D0\u4EA4",
  "login.password.new.placeholder": "\u8BF7\u8F93\u5165\u65B0\u5BC6\u7801",
  "login.password.new.confirm.placeholder": "\u8BF7\u8F93\u5165\u786E\u8BA4\u65B0\u5BC6\u7801",
  "login.back": "\u8FD4\u56DE\u767B\u5F55",
  "login.phoneNumber.required": "\u8BF7\u8F93\u5165\u624B\u673A\u53F7"
};

// ../max/_utils/intl/locales/en-US.ts
var en_US_default = {
  "request.response_status_code.400": "Bad request",
  "request.response_status_code.401": "Unauthorized",
  "request.response_status_code.403": "Forbidden",
  "request.response_status_code.404": "Not found",
  "request.response_status_code.408": "Request timeout",
  "request.response_status_code.500": "Internal server error",
  "request.response_status_code.502": "Bad gateway",
  "request.response_status_code.503": "Service unavailable",
  "request.response_status_code.504": "Gateway timeout",
  "request.response_status_code.other": "Connection error",
  "request.no_response": "Server no response",
  "request.error": "Request error",
  "login.btn.login": "Login",
  "login.btn.logout": "Logout",
  "login.btn.forgot_password": "Forgot Password",
  "login.btn.edit_password": "Edit Password",
  "login.captcha.phone": "Phone Number",
  "login.captcha.email": "Email",
  "login.placeholder.phone": "Please input phone number",
  "login.placeholder.email": "Please input email",
  "login.type.account": "Account Login",
  "login.type.captcha": "Captcha Login",
  "login.type.feishu": "Lark Login",
  "login.input.required": "Please input",
  "login.password.mismatch": "The two passwords you entered do not match!",
  "login.password.required": "Please input password",
  "login.verification.required": "Please input verification code",
  "login.verification.placeholder": "Please input verification code",
  "login.verification.get": "Get verification code",
  "login.password.confirm.required": "Please input confirm password",
  "login.password.confirm.placeholder": "Please input confirm password",
  "login.submit": "Submit",
  "login.password.new.placeholder": "Please input new password",
  "login.password.new.confirm.placeholder": "Please input confirm new password",
  "login.back": "Back to login",
  "login.phoneNumber.required": "Please input phone number"
};

// ../max/_utils/intl/locales/ja-JP.ts
var ja_JP_default = {
  "request.response_status_code.400": "\u30EA\u30AF\u30A8\u30B9\u30C8\u30A8\u30E9\u30FC",
  "request.response_status_code.401": "\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044",
  "request.response_status_code.403": "\u30A2\u30AF\u30BB\u30B9\u304C\u62D2\u5426\u3055\u308C\u307E\u3057\u305F",
  "request.response_status_code.404": "\u30EA\u30AF\u30A8\u30B9\u30C8\u30A2\u30C9\u30EC\u30B9\u306E\u30A8\u30E9\u30FC",
  "request.response_status_code.408": "\u30EA\u30AF\u30A8\u30B9\u30C8\u30BF\u30A4\u30E0\u30A2\u30A6\u30C8",
  "request.response_status_code.500": "\u30B5\u30FC\u30D0\u30FC\u5185\u90E8\u30A8\u30E9\u30FC",
  "request.response_status_code.502": "\u30B2\u30FC\u30C8\u30A6\u30A7\u30A4 \u30A8\u30E9\u30FC",
  "request.response_status_code.503": "\u30B5\u30FC\u30D3\u30B9\u304C\u5229\u7528\u3067\u304D\u307E\u305B\u3093",
  "request.response_status_code.504": "\u30B2\u30FC\u30C8\u30A6\u30A7\u30A4\u30BF\u30A4\u30E0\u30A2\u30A6\u30C8",
  "request.response_status_code.other": "\u63A5\u7D9A\u30A8\u30E9\u30FC",
  "request.no_response": "\u63A5\u7D9A\u30A8\u30E9\u30FC",
  "request.error": "\u30EA\u30AF\u30A8\u30B9\u30C8\u30A8\u30E9\u30FC",
  "login.btn.login": "\u30ED\u30B0\u30A4\u30F3",
  "login.btn.logout": "\u30ED\u30B0\u30A2\u30A6\u30C8",
  "login.btn.forgot_password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F",
  "login.btn.edit_password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4",
  "login.captcha.phone": "\u643A\u5E2F\u96FB\u8A71\u756A\u53F7",
  "login.captcha.email": "\u96FB\u5B50\u30E1\u30FC\u30EB",
  "login.placeholder.phone": "\u643A\u5E2F\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  "login.placeholder.email": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  "login.type.account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u30ED\u30B0\u30A4\u30F3",
  "login.type.captcha": "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u30ED\u30B0\u30A4\u30F3",
  "login.type.feishu": "\u30D5\u30A7\u30A4\u30B7\u30E5\u30ED\u30B0\u30A4\u30F3",
  "login.input.required": "\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  "login.password.mismatch": "\u5165\u529B\u3057\u305F2\u3064\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u4E00\u81F4\u3057\u307E\u305B\u3093",
  "login.password.required": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  "login.verification.required": "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  "login.verification.placeholder": "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  "login.verification.get": "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u53D6\u5F97",
  "login.password.confirm.required": "\u78BA\u8A8D\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  "login.password.confirm.placeholder": "\u78BA\u8A8D\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  "login.submit": "\u9001\u4FE1",
  "login.password.new.placeholder": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  "login.password.new.confirm.placeholder": "\u78BA\u8A8D\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  "login.back": "\u30ED\u30B0\u30A4\u30F3\u753B\u9762\u306B\u623B\u308B",
  "login.phoneNumber.required": "\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
};

// ../max/_utils/intl/index.ts
var getLocale = () => {
  const lang = navigator.cookieEnabled && typeof localStorage !== "undefined" ? window.localStorage.getItem("umi_locale") : "";
  const isNavigatorLanguageValid = typeof navigator !== "undefined" && typeof navigator.language === "string";
  const browserLang = isNavigatorLanguageValid ? navigator.language.split("-").join("-") : "";
  return lang || browserLang || "zh-CN";
};
var getT = () => {
  const locale = getLocale();
  const locales = {
    ["zh-CN" /* ZH_CN */]: zh_CN_default,
    ["en-US" /* EN_US */]: en_US_default,
    ["ja-JP" /* JA_JP */]: ja_JP_default
  }[locale];
  return (text) => {
    return (locales == null ? void 0 : locales[text]) || text;
  };
};

// errorHandler.ts
var responseStatusCodeError = (error) => {
  const { status } = error.response;
  const t = getT();
  const codeMap = {
    400: t("request.response_status_code.400"),
    401: t("request.response_status_code.401"),
    403: t("request.response_status_code.403"),
    404: t("request.response_status_code.404"),
    408: t("request.response_status_code.408"),
    500: t("request.response_status_code.500"),
    502: t("request.response_status_code.502"),
    503: t("request.response_status_code.503"),
    504: t("request.response_status_code.504")
  };
  const msg = codeMap[status] || t("request.response_status_code.other");
  return `${msg} (${status})`;
};
var errorHandler = (error) => {
  const t = getT();
  let msg;
  if (error.response) {
    msg = responseStatusCodeError(error);
  } else if (error.request) {
    msg = t("request.no_response");
  } else {
    msg = `${t("request.error")}: ${error.message}`;
  }
  return msg;
};
var errorHandler_default = errorHandler;

// index.ts
var getAxiosInstance = (initConfig, lifecycle) => {
  const instance = axios.create(
    assign(
      {
        timeout: 60 * 1e3,
        adapter: "fetch"
      },
      initConfig || {}
    )
  );
  instance.interceptors.request.use(
    (config) => {
      var _a;
      if (config.method === "post" && config.data instanceof FormData) {
        config.headers.set("Content-Type", "multipart/form-data");
      }
      (_a = lifecycle == null ? void 0 : lifecycle.beforeRequest) == null ? void 0 : _a.call(lifecycle, config);
      return config;
    },
    (error) => {
      console.error(error);
      return Promise.reject(error);
    }
  );
  instance.interceptors.response.use(
    (response) => {
      if (lifecycle == null ? void 0 : lifecycle.beforeResponse) {
        return lifecycle.beforeResponse(response);
      }
      return response.data;
    },
    (error) => {
      var _a;
      (_a = lifecycle == null ? void 0 : lifecycle.onError) == null ? void 0 : _a.call(lifecycle, errorHandler_default(error));
      console.error(error);
      return Promise.reject(error);
    }
  );
  return instance;
};
export {
  getAxiosInstance
};
